"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchStyles = void 0;
const lit_1 = require("lit");
const shared_styles_1 = require("@/stylesheets/shared.styles");
exports.switchStyles = (0, lit_1.css) `
  :host {
    --switch-width: var(--size-32);
    --switch-height: var(--size-16);
    --switch-border-radius: var(--radius);
    --switch-background-color: var(--border-color);
    display: block;
    height: var(--switch-height);
    position: relative;
  }

  input:focus-visible + label:before {
    ${shared_styles_1.focusRingStyles};
  }

  input {
    opacity: 0;
    position: absolute;
    inset: calc(var(--space-2) * -1);
    inline-size: 100%;

    &:checked + label {
      --switch-background-color: var(--interaction-selected-foreground-color);

      &:after {
        /* 썸은 트랙 높이만 한 정사각형이라, 이동 거리는 트랙 너비에서 썸 크기를 뺀 값이다. */
        transform: translateX(calc(var(--switch-width) - var(--switch-height)));
      }
    }

    &:disabled + label {
      ${shared_styles_1.disabledStyles};
    }
  }

  label {
    display: flex;
    gap: var(--space-2);
    line-height: var(--switch-height);
    cursor: pointer;

    &:before {
      content: '';
      display: block;
      width: var(--switch-width);
      height: var(--switch-height);
      border-radius: var(--switch-border-radius);
      box-sizing: border-box;
      background: var(--switch-background-color);
      transition: all var(--transition-duration) var(--transition-easing);
    }

    &:after {
      content: '';
      display: block;
      width: var(--switch-height);
      height: var(--switch-height);
      border: var(--border);
      border-radius: var(--switch-border-radius);
      box-sizing: border-box;
      background: var(--background-color);
      position: absolute;
      left: 0;
      top: 0;
      transition: transform var(--transition-duration) var(--transition-easing);
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3dpdGNoLnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN3aXRjaC5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQXlCO0FBRXpCLCtEQUE2RTtBQUVoRSxRQUFBLFlBQVksR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7O01BWXpCLCtCQUFlOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O1FBbUJiLDhCQUFjOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FvQ3JCLENBQUEifQ==